
var Model = require("../types/Model.js");

var REPEAT_INTEVAL = 4 * 1000;
var REPEAT_AMOUNT = 2;
var REACTION_DELAY = 2 * 1000;

module.exports = Model({
	name: "availabilitynotifier",
	init: init,
	uninit: uninit,
	listeners: listeners,
	notify_online: notify_online,
	emit_online: emit_online,
	clear_interval: clear_interval,

	_interval_id: null,
	_emit_id: null,
});

function init() {
	this.push({
		available: false
	});
}

function uninit() {
	this.clear_interval();
	clearTimeout(this._emit_id);
}

function listeners() {
	return {
		"connectivity:online": notify_online,
		"personal:updated": handle_personal_update,
		"mqtt:$/status/available": handle_availability_changed
	};
}

/**
 * Called when the connection is re-established to MQTT.
 * Emits that the current user is now online
 */
function notify_online() {
	this.clear_interval();
	if (!this.data) return;
	if (!this.data.available) return;
	var repeats = REPEAT_AMOUNT;
	this._interval_id = setInterval(do_loop.bind(this), REPEAT_INTEVAL);

	function do_loop() {
		if (!(repeats--)) return this.clear_interval();
		this.emit_online();
	}
}

function emit_online() {
	this.emit("$mqtt:$/status/available", {
		status: true
	});
}

function handle_personal_update(data) {
	var available = data.available;
	this.extend({
		available: available
	});
	this.notify_online();
}

function clear_interval() {
	if (!this._interval_id) return;
	clearInterval(this._interval_id);
	this._interval_id = null;
}

function handle_availability_changed(data) {
	if (!this.data.available) return;
	var status = data.status;
	if (status) return;

	clearTimeout(this._emit_id);
	this._emit_id = setTimeout(emit_online.bind(this), REACTION_DELAY);
}
